module.exports = __webpack_public_path__ + "img/img6.5bfb9f57.png";